import styled from 'styled-components'

import type { ComponentPropsWithoutRef } from 'react'

/* ------------------------------------------------------------------------------------------------- *
 * MedicationPhotoThumbnail
 * ------------------------------------------------------------------------------------------------- */

/** `alt` is required: describe the photo, or pass `''` only when the image is purely decorative. */
type MedicationPhotoThumbnailProps = ComponentPropsWithoutRef<'img'> & { alt: string }

const MedicationPhotoThumbnail = (props: MedicationPhotoThumbnailProps) => <StThumbnail {...props} />

export { MedicationPhotoThumbnail }

/* ------------------------------------------------------------------------------------------------- *
 * Styled
 * ------------------------------------------------------------------------------------------------- */

const StThumbnail = styled.img`
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  object-fit: cover;

  ${({ theme }) => `
    border-radius: ${theme.UI.BorderRadius.Small};
  `}
`
